'use client';

import { ElementNode } from 'lexical';

export class ColumnsNode extends ElementNode {
  __cols

  static getType() { return 'columns'; }

  static clone(node) {
    return new ColumnsNode(node.__cols, node.__key);
  }

  constructor(cols = 2, key) {
    super(key);
    this.__cols = cols;
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = this._gridClass();
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__cols !== this.__cols) {
      dom.className = this._gridClass();
    }
    return false;
  }

  _gridClass() {
    const cols = this.getLatest().__cols;
    return `my-6 grid gap-6 ${cols === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'} grid-cols-1`;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'columns',
      version: 1,
      cols: this.__cols,
    };
  }

  static importJSON(data) {
    return new ColumnsNode((data.cols) ?? 2);
  }

  // Allow block children inside columns container
  static importDOM() { return null; }
  isInline() { return false; }
  canBeEmpty() { return false; }
  canBeNested() { return false; }
  isShadowRoot() { return false; }
}
export function $createColumnsNode(cols = 2) {
  return new ColumnsNode(cols);
}
export function $isColumnsNode(node) {
  return node instanceof ColumnsNode;
}
